module.exports = __webpack_public_path__ + "static/img/lean.90e3d7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/lean.jpg
// module id = xcPX
// module chunks = 0